import { render, staticRenderFns } from "./TaskTypeList.vue?vue&type=template&id=f3a337b2"
import script from "./TaskTypeList.vue?vue&type=script&lang=js"
export * from "./TaskTypeList.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports